module.exports = __webpack_public_path__ + "img/icon_mark_art.26f97cf3.png";